import { Observable } from 'rxjs';
import { PolizaDTO, GetPolizaDTO, PDFPolizaDTO} from '../../data/dto/PolizaDTO';
import { PDFCotizacionDTO, GetCotizacionDTO, SendPolizaDTO, SendPolizaRequestDTO, SendComparativeDTO, SendCotizacionComparativeDTO } from '../../data/dto/PolizaDTO';
import { QuotationDTO } from 'src/app/data/dto/QuotationDTO';

export abstract class PolizaRepository {
    abstract createPoliza(poliza: GetPolizaDTO): Observable<PolizaDTO>;
    abstract getPolizaPDF(file: GetPolizaDTO): Observable<PDFPolizaDTO>;
    abstract getCotizacionPDF(file: GetCotizacionDTO): Observable<PDFCotizacionDTO>;
    abstract getCotizacionComparativoPDF(file: SendCotizacionComparativeDTO): Observable<PDFCotizacionDTO>;
    abstract getCotizacionPDFAgentes(file: GetCotizacionDTO): Observable<PDFCotizacionDTO>;
    abstract getCotizacionPDFAgentesSin(file: GetCotizacionDTO): Observable<PDFCotizacionDTO>;
    abstract getComparativoPDF(idCotizacion:number, cotizaciones: QuotationDTO[]): Observable<PDFCotizacionDTO>;
    abstract printCotizacionPDF(file: GetCotizacionDTO): Observable<PDFCotizacionDTO>;
    abstract sendPolizaPDF(file: SendPolizaDTO): Observable<SendPolizaRequestDTO>;
    abstract sendPolizaPDFWithoutPay(file: SendPolizaDTO): Observable<SendPolizaRequestDTO>;
    abstract sendPolizaComparative(file: SendComparativeDTO): Observable<PDFCotizacionDTO>;
}
